/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Navbar } from 'reactstrap'
import { LazyLoadImage } from 'react-lazy-load-image-component'

export default function Header() {
  return (
    <>
      <section className="border-bottom" id="header-bar">
        <Navbar color="faded" className="container navbar-style" light>
          <div className="mr-auto py-2">
            {/* TODO add dynamic brands */}
            <LazyLoadImage
              id="logo"
              alt="logo"
              height="40px"
              src={
                window.data && window.data.logo
                  ? window.data.log
                  : 'https://upload.convolab.ai/viriyah-dev%2F8b292a29-884b-4438-bf80-7c30aba37e22.png'
              }
              width="100%"
            />
          </div>
        </Navbar>
      </section>
    </>
  )
}
